import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-results', {
  key: 'admin-results',
  label: 'Results',
  getSteps: () => [
    introStep({
      title: 'Results Hub',
      content:
        '"Score Entry" is the marks book, "View Results" is the per-student/term result screen. "Broadsheet" and "Summary" produce class-wide reports — and "Templates" lets you customize how results are formatted. For tertiary schools, you also get Course Transfer and Transcript tabs.',
    }),
  ],
});
